import React, { useState } from "react";

const UNIT_LABELS = { day: "days", week: "weeks", month: "months" };

function tomorrowStr() {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// Naptári másolás: hány alkalommal vagy milyen végdátumig, emberekkel vagy nélkülük.
// Elemnél a lépték (nap/hét/hónap) is választható; napnál, hétnél, hónapnál rögzített.
export default function CalendarCopyDialog({
  title,
  planCount,
  unit: fixedUnit = null,
  showShiftOption = false,
  onConfirm,
  onClose,
  busy = false,
}) {
  const [unit, setUnit] = useState(fixedUnit || "week");
  const [mode, setMode] = useState("count");
  const [count, setCount] = useState(1);
  const [until, setUntil] = useState("");
  const [includePeople, setIncludePeople] = useState(true);
  const [includeShifts, setIncludeShifts] = useState(true);

  const valid = mode === "count" ? Number(count) >= 1 : !!until;

  const submit = (event) => {
    event.preventDefault();
    if (!valid) return;
    onConfirm({
      unit,
      ...(mode === "count" ? { count: Number(count) } : { until }),
      include_people: includePeople,
      include_shifts: includeShifts,
    });
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/30" onClick={onClose}>
      <form
        role="dialog"
        aria-label="Copy plans"
        onSubmit={submit}
        onClick={(event) => event.stopPropagation()}
        className="w-80 rounded-xl border border-slate-200 bg-white p-4 text-sm text-slate-700 shadow-2xl"
      >
        <div className="font-bold text-slate-800">{title}</div>
        <div className="mb-3 text-xs text-slate-500">{planCount} plan{planCount === 1 ? "" : "s"} · only future dates are created</div>

        {!fixedUnit && (
          <label className="mb-3 flex items-center justify-between gap-2">
            <span>Repeat every</span>
            <select
              aria-label="Repeat unit"
              value={unit}
              onChange={(event) => setUnit(event.target.value)}
              className="rounded border border-slate-300 px-2 py-1"
            >
              <option value="day">day</option>
              <option value="week">week</option>
              <option value="month">month</option>
            </select>
          </label>
        )}

        <label className="mb-2 flex items-center gap-2">
          <input type="radio" name="copy-mode" checked={mode === "count"} onChange={() => setMode("count")} />
          <span>For the next</span>
          <input
            type="number"
            min="1"
            max="366"
            aria-label="Number of repetitions"
            value={count}
            onFocus={() => setMode("count")}
            onChange={(event) => setCount(event.target.value)}
            className="w-16 rounded border border-slate-300 px-2 py-1"
          />
          <span>{UNIT_LABELS[unit]}</span>
        </label>

        <label className="mb-3 flex items-center gap-2">
          <input type="radio" name="copy-mode" checked={mode === "until"} onChange={() => setMode("until")} />
          <span>Until</span>
          <input
            type="date"
            aria-label="End date"
            min={tomorrowStr()}
            value={until}
            onFocus={() => setMode("until")}
            onChange={(event) => { setUntil(event.target.value); setMode("until"); }}
            className="rounded border border-slate-300 px-2 py-1"
          />
        </label>

        <label className="mb-4 flex items-center gap-2">
          <input
            type="checkbox"
            aria-label="Copy assigned people"
            checked={includePeople}
            onChange={(event) => setIncludePeople(event.target.checked)}
          />
          <span>Copy assigned people too</span>
        </label>

        {showShiftOption && (
          <label className="mb-4 flex items-center gap-2">
            <input
              type="checkbox"
              aria-label="Copy shifts"
              checked={includeShifts}
              onChange={(event) => setIncludeShifts(event.target.checked)}
            />
            <span>Copy shifts too</span>
          </label>
        )}

        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded border border-slate-300 px-3 py-1.5 text-slate-600 hover:bg-slate-50">
            Cancel
          </button>
          <button
            type="submit"
            disabled={!valid || busy}
            className="rounded bg-teal-500 px-3 py-1.5 font-semibold text-white hover:bg-teal-600 disabled:opacity-50"
          >
            {busy ? "Copying…" : "Copy"}
          </button>
        </div>
      </form>
    </div>
  );
}
